import PropTypes from "prop-types";
import { useFilterContext } from "../../contexts/FilterProvider";
import { FilterPopoverForm } from "./FilterPopoverForm";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { TripAdvisor } from "app/icons/brands/TripAdvisor";
import { SDP_PRODUCTS_FILTERS_KEY } from "app/constants";
import { useFormikContext } from "formik";
import { AnimatedWidthButton } from "app/features/product/components/animatedWidthButton/AnimatedWidthButton";
import { FilterSortPopover } from "app/features/product/components/filterSortPopover/FilterSortPopover";

export const FilterPopover = ({
	facetId,
	onOpen,
	onClose,
	onToggle,
	onSubmit,
	showSelectedCount = true,
	children,
	boundaryRef,
}) => {
	const { activeFacetId, openFacet, closeFacet, filters } = useFilterContext();
	const { resetForm } = useFormikContext();
	const selectedFiltersCount = filters?.[facetId]?.length || 0;
	const open = activeFacetId === facetId;

	return (
		<FilterSortPopover.Root
			id={facetId}
			open={open}
			onOpen={({ id }) => {
				openFacet(id);

				if (onOpen) {
					onOpen({ id });
				}
			}}
			onClose={({ id }) => {
				closeFacet();
				resetForm({ values: filters });

				if (onClose) {
					onClose({ id });
				}
			}}
			onToggle={onToggle}
			boundaryRef={boundaryRef}
		>
			<FilterSortPopover.Trigger>
				<AnimatedWidthButton
					isActive={open || (showSelectedCount && selectedFiltersCount > 0)}
					isOpen={open}
					selectedFiltersCount={showSelectedCount ? selectedFiltersCount : null}
					data-testid={`${facetId}-filter-button`}
				>
					<Typography component="span" variant={TYPOGRAPHY_VARIANTS.SMALL}>
						{children}
					</Typography>

					{facetId === SDP_PRODUCTS_FILTERS_KEY.GUESTS_RATING && (
						<TripAdvisor size={12} />
					)}

					{selectedFiltersCount > 0 && (
						<Typography component="span" variant={TYPOGRAPHY_VARIANTS.SMALL}>
							({selectedFiltersCount})
						</Typography>
					)}
				</AnimatedWidthButton>
			</FilterSortPopover.Trigger>

			<FilterSortPopover.Content>
				<FilterPopoverForm facetId={facetId} onSubmit={onSubmit} />
			</FilterSortPopover.Content>
		</FilterSortPopover.Root>
	);
};

FilterPopover.propTypes = {
	facetId: PropTypes.string.isRequired,
	onOpen: PropTypes.func,
	onClose: PropTypes.func,
	onToggle: PropTypes.func,
	onSubmit: PropTypes.func,
	showSelectedCount: PropTypes.bool,
	children: PropTypes.node,
	boundaryRef: PropTypes.shape({
		current: PropTypes.object,
	}),
};
